import { create } from 'zustand';
import type { IMeInfo } from '@/types/auth';

interface AuthStore {
  meInfo: IMeInfo | null;
  isLoggedInViaUAEPass: boolean;
  uaePassIdToken: string | null;
  uaePassError: string | null;
  setMeInfo: (meInfo: IMeInfo) => void;
  setLoggedInViaUAEPass: (val: boolean) => void;
  setUaePassIdToken: (token: string | null) => void;
  setUaePassError: (err: string | null) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthStore>((set) => ({
  meInfo: null,
  isLoggedInViaUAEPass: false,
  uaePassIdToken: null,
  uaePassError: null,
  setMeInfo: (meInfo) => set({ meInfo }),
  setLoggedInViaUAEPass: (val) => set({ isLoggedInViaUAEPass: val }),
  setUaePassIdToken: (token) => set({ uaePassIdToken: token }),
  setUaePassError: (err) => set({ uaePassError: err }),
  clearAuth: () => set({ meInfo: null, isLoggedInViaUAEPass: false, uaePassIdToken: null, uaePassError: null }),
}));
